// import { enumDrawerPlacement } from "@configs";
import { ReactNode } from "react";
import styled from "styled-components";
import { Drawer } from "antd";
import { enumDrawerPlacement } from "@configs";
interface IProps {
    title: string;
    placement: enumDrawerPlacement;
    onClose: () => void;
    visible: boolean;
    children: ReactNode;
    width?: number | string;
    height?: number | string;
    style?: any;
}

export const SharedComponentDrawer = (props: IProps) => {
    const { title, onClose, placement, visible, children, width, height, style } = props;
    return (
        <StyledDrawer
            title={title}
            placement={placement}
            closable={false}
            onClose={onClose}
            open={visible}
            width={width}
            height={height}
            style={style}
        >
            {children}
        </StyledDrawer>
    );
};
const StyledDrawer = styled(Drawer)`
    .ant-drawer-body {
        padding: 0;
        height: 100% !important;
        margin-bottom: 4rem;
        .add-sub-btn {
            font-style: normal;
            font-weight: 400;
            font-size: 16px;
            line-height: 22px;
            color: #0263e0;
            margin: 0;
            cursor: pointer;
        }
        .title {
            font-style: normal;
            font-weight: 500;
            font-size: 16px;
            line-height: 22px;
            color: #000000;
            margin-bottom: 20px;
        }
        .btn-layout {
            position: absolute;
            bottom: 16px;
        }
    }
    .avatar {
        margin-bottom: 42px;
        position: relative;
        .box_title {
            display: flex;
            align-items: center;
            justify-content: flex-start;
            p {
                margin: 0 4px 0 0;
            }
            button {
                padding: 0 4px;
                border: 0;
                background: transparent;
                height: auto;
            }
        }
    }
    .avatar .box_title {
        margin: 0 0 20px 0px;
        font-style: normal;
        font-weight: 600;
        font-size: 16px;
        line-height: 1.5em;
    }
    .avatar-layout {
        position: relative;
        width: 110px;
        &:hover {
            .remove-icon-layout {
                visibility: visible;
            }
        }
    }
    .remove-icon-layout {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.3);
        visibility: hidden;
        display: flex;
        justify-content: end;
        padding: 8px;
    }
    .minimumQtyDiv {
        border-bottom: 0.5px solid #a5a5a5;
        padding-bottom: 2rem;
        margin-bottom: 1rem;
    }
    .closeBtn {
        position: absolute;
        top: 20px;
        right: 20px;
        cursor: pointer;
        font-size: 18px;
    }
    .swiper-slide img {
        width: 100%;
        height: 160px;
        object-fit: cover;
    }
    .swiper-pagination {
        color: #fff;
        top: 5px;
        right: 10px;
        left: auto !important;
        width: auto;
    }
    .topServiceTitle {
        font-size: 16px;
        font-weight: 500;
        color: #000;
        line-height: 22px;
    }
    .drawerBody .description {
        color: #a5a5a5;
        font-size: 14px;
        font-weight: 500;
        line-height: 19px;
    }
    .priceAndArrow h2 {
        font-size: 14px;
        line-height: 22px;
        font-weight: 400;
        color: #000;
    }
    .drawerBody {
        padding: 24px;
        border-bottom: 5px solid #fbfbfb;
    }
    .variantSection {
        padding: 24px;
        border-bottom: 5px solid #fbfbfb;
    }
    .notationSection {
        padding: 24px;
    }
    .variantSection img {
        width: 32px;
        height: 32px;
        border-radius: 4px;
        margin-right: 5px;
    }
    .ant-radio-checked .ant-radio-inner {
        background: #f22f46;
        border: none;
    }
    .ant-radio-inner::after {
        top: 2.5px;
        left: 6.2px;
        background-color: transparent;
        border-radius: 0px;
        display: inline-block;
        -webkit-transform: rotate(45deg) !important;
        -ms-transform: rotate(45deg) !important;
        transform: rotate(45deg) !important;
        height: 9px;
        width: 5px;
        border-bottom: 1.5px solid #fff;
        border-right: 1.5px solid #fff;
    }
    .ant-radio-checked::after {
        border: 1px solid #f22f46;
    }
    .ant-radio-wrapper:hover .ant-radio {
        border-color: #f22f46;
    }
    .ant-radio-group {
        width: 100%;
    }
    .radioPriceDiv {
        position: absolute;
        right: 0;
        top: 0;
    }
    .radioPrice {
        color: #000;
        font-size: 14px;
    }
    .oldRadioPrice {
        color: #a0a4ab;
        font-size: 10px;
        text-decoration: line-through;
        margin-right: 5px;
    }
    .variantSection .ServiceTitle {
        margin-bottom: 20px;
    }
    .ant-radio-inner {
        width: 17px;
        height: 17px;
    }
    .ant-drawer-content {
        border-top-left-radius: 8px;
        border-top-right-radius: 8px;
    }
`;
